/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import {
  Box,
  Card,
  CardContent,
  InputAdornment,
  makeStyles,
  MenuItem,
  Typography,
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'

import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BaseFilter from '../../../../../components/hooks/BaseFilter'
import {
  getDecimalPart,
  getIntegerPart,
  useQueryParams,
} from '../../../../../util/utils'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiMagnify, mdiMagnifyExpand, mdiNoteEditOutline } from '@mdi/js'
import filterStylesComponents from '../../../../../assets/filterComponentsStyles'
import SelectField from '../../../../components/SelectField'
import { fetchServiceType } from '../../../../service-type/ServiceTypeActions'
import { fetchServiceCategory } from '../../../../service-category/ServiceCategoryActions'
import CountUp from 'react-countup'
import colors from '../../../../../assets/colors'

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '10px',
    border: `1px solid ${colors.graylight}`,
    padding: '0',
    color: colors.primary,
  },
  differenceValue: {
    color: colors.sucess,
    marginRight: theme.spacing(1),
  },
  differenceValueNegative: {
    color: colors.error,
    marginRight: theme.spacing(1),
  },
  noDifference: {
    color: colors.graylight,
    marginRight: theme.spacing(1),
  },
  value: {
    flex: 1,
    color: colors.primary,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '24px',
  },
  title: {
    color: colors.primary,
    fontSize: '13px',
    lineHeight: '18px',
  },
  cents: {
    fontSize: '16px',
    fontWeight: '400',
  },
  filterButton: {
    fontSize: '13px',
    lineHeight: '10px',
    color: colors.primary,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}))

export const Filter = ({ classes }) => {
  const permissions = useSelector(state => state.auth.permissions)
  const serviceCategory = useSelector(state => state.serviceCategory.items)
  const cashback = useSelector(state => state.client.cashback)
  const laundryClient = useSelector(state => state.pointValue.laundryClient)

  const dispatch = useDispatch()

  const styles = filterStylesComponents()
  const card = useStyles()

  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location?.search)

  const [open, setOpen] = useState(false)

  // const serviceCategoryFiltered = useMemo(() => {
  //   if (!serviceCategory?.length) return ''
  //   if (!filters?.service_category_id) return ''
  //   return serviceCategory?.find(r => r?.id == filters?.service_category_id)
  // }, [serviceCategory, filters])

  const toggleModal = () => {
    setOpen(!open)
  }

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.replace(`${location?.pathname}?${searchParams?.toString()}`)
  }

  // const handleChangeServiceType = (name, value) => {
  //   const data = {
  //     ...filters,
  //     [name]: value?.id || '',
  //   }
  //   onSubmit({ ...filters, ...data })
  // }

  // const handleSubmit = e => {
  //   e.preventDefault()

  //   const formData = e.currentTarget
  //   const data = new FormData(formData)

  //   const entries = data.entries()
  //   const values = Object.fromEntries(entries)

  //   onSubmit({ ...filters, ...values })
  // }

  // useEffect(() => {
  //   dispatch(fetchServiceCategory())
  // }, [])

  const contUp = money => {
    if (!money) {
      return (
        <CountUp end={0} duration={0.8} prefix="R$" decimal="," separator="." />
      )
    }

    const integerPart = money?.toString().split('.')

    return (
      <CountUp
        end={integerPart[0] || 0}
        duration={0.8}
        prefix="R$"
        decimal=","
        separator="."
      />
    )
  }

  const contUpDecimals = money => {
    if (money === 0) return ',00'
    const decimalPart = getDecimalPart(money)
    return <>{','+ decimalPart}</>
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={8}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} className={card.filterButton}>
            <Typography className={card.title}>
              Total de pontos:
            </Typography>
            <Typography className={card.value}>
              {cashback?.total_points || 0}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} className={card.filterButton}>
            <Typography className={card.title}>
              Valor Total:
            </Typography>
            <Typography className={card.value}>
              {contUp(
                (cashback?.total_points || 0) * (laundryClient?.cashback_point_value || 0)
              )}
              <span className={card.cents}>
                {contUpDecimals(
                  (cashback?.total_points || 0) * (laundryClient?.cashback_point_value || 0)
                )}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={4} container className={styles.areaButtons}>
        {/* Espaço reservado para botões futuros como "Outros Filtros" ou "Exportar" */}
      </Grid>
    </Grid>
  )
}
